{
  "version": 5,
  "items": [
    {
      "id": "bakery-window-warmth",
      "name": "Bakery Window Jumper",
      "description": "A chunky knitted jumper that holds the warmth of a bakery window at dawn. It smells of butter and good intentions.",
      "rarity": "common",
      "emoji": "🧶",
      "palette": "#FFA94D",
      "slot": "body"
    },
    {
      "id": "balloon-ribbon",
      "name": "Balloon on a Ribbon",
      "description": "A cheerful balloon on a curly ribbon, held tight so it can't float off to see the world. It bobs higher on hopeful days.",
      "rarity": "common",
      "emoji": "🎈",
      "palette": "#F72585",
      "slot": "hand"
    },
    {
      "id": "bottled-birdsong",
      "name": "Morning Songbird",
      "description": "A tiny songbird that perches near your shoulder and chirps one sunrise note whenever your mood needs it.",
      "rarity": "common",
      "emoji": "🐦",
      "palette": "#6BCB77",
      "slot": "companion"
    },
    {
      "id": "bubble-pop-echo",
      "name": "Bubble Wand",
      "description": "A schoolyard bubble wand that never runs dry. Every bubble it blows pops with one tiny cheer.",
      "rarity": "common",
      "emoji": "🫧",
      "palette": "#C77DFF",
      "slot": "hand"
    },
    {
      "id": "bumblebee-hum",
      "name": "Bumblebee Buddy",
      "description": "A fuzzy bumblebee that hums along beside you, turning any ordinary walk into a garden party.",
      "rarity": "common",
      "emoji": "🐝",
      "palette": "#FFC300",
      "slot": "companion"
    },
    {
      "id": "bus-stop-breeze",
      "name": "Bus Stop Scarf",
      "description": "A light scarf that flutters in a breeze only it can feel, like waiting at a windy bus stop on a sunny day.",
      "rarity": "common",
      "emoji": "🧣",
      "palette": "#7FDBFF",
      "slot": "neck"
    },
    {
      "id": "cat-nap-sunspot",
      "name": "Sunspot Kitten",
      "description": "A drowsy kitten that follows the warmest patch of sunlight, which somehow always lands right next to you.",
      "rarity": "common",
      "emoji": "🐈",
      "palette": "#FFCA3A",
      "slot": "companion"
    },
    {
      "id": "coffee-cup-cloud",
      "name": "Coffee Cup Cloud",
      "description": "A small steamy cloud that drifted up from a café cup and decided to follow you home. It smells faintly of cocoa.",
      "rarity": "common",
      "emoji": "☁️",
      "palette": "#A0E7E5",
      "slot": "companion"
    },
    {
      "id": "crosswalk-chirp",
      "name": "Crosswalk Vest",
      "description": "A bright safety vest that chirps politely whenever it's your turn to cross. Drivers always seem to smile.",
      "rarity": "common",
      "emoji": "🦺",
      "palette": "#2EC4B6",
      "slot": "body"
    },
    {
      "id": "crumb-of-sunshine",
      "name": "Sunshine Cap",
      "description": "A cap with a crumb of sunshine tucked under the brim. Your face stays sunny even on grey afternoons.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#FFB000",
      "slot": "head"
    },
    {
      "id": "curbside-clover",
      "name": "Clover Face Paint",
      "description": "A tiny four-leaf clover painted on one cheek, picked from a lucky curb. It never smudges, even in the rain.",
      "rarity": "common",
      "emoji": "🍀",
      "palette": "#2ECC71",
      "slot": "face"
    },
    {
      "id": "dandelion-wish",
      "name": "Dandelion Crown",
      "description": "A crown of dandelions woven at the edge of a park. Every flower holds one small unspoken wish.",
      "rarity": "common",
      "emoji": "🌼",
      "palette": "#FFE066",
      "slot": "head"
    },
    {
      "id": "doorbell-ding",
      "name": "Doorbell Pendant",
      "description": "A little brass bell on a ribbon that dings a friendly hello whenever you arrive somewhere new.",
      "rarity": "common",
      "emoji": "🔔",
      "palette": "#F15BB5",
      "slot": "neck"
    },
    {
      "id": "firefly-freckle",
      "name": "Firefly Freckles",
      "description": "Freckles that glow softly at dusk, borrowed from a firefly who had plenty to spare.",
      "rarity": "common",
      "emoji": "✨",
      "palette": "#FFEA00",
      "slot": "face"
    },
    {
      "id": "fountain-coin-wink",
      "name": "Fountain Coin Monocle",
      "description": "A wishing-fountain coin worn as a monocle. Look through it and everything seems to wink back.",
      "rarity": "common",
      "emoji": "🪙",
      "palette": "#F7C548",
      "slot": "face"
    },
    {
      "id": "giggling-pebble",
      "name": "Giggling Pebble Dungarees",
      "description": "Sturdy dungarees with a giggling pebble in the front pocket. They chuckle whenever you sit down.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#FFB347",
      "slot": "body"
    },
    {
      "id": "gumdrop-pebble",
      "name": "Gumdrop Bead Necklace",
      "description": "A string of glossy gumdrop beads, each found sparkling on a pavement. They are not for eating, however tempting.",
      "rarity": "common",
      "emoji": "🍬",
      "palette": "#FF70A6",
      "slot": "neck"
    },
    {
      "id": "hopscotch-pebble",
      "name": "Hopscotch Dance Shoes",
      "description": "Soft dance shoes that remember every hopscotch grid they've crossed. They land lightly on every square.",
      "rarity": "common",
      "emoji": "🩰",
      "palette": "#4361EE",
      "slot": "feet"
    },
    {
      "id": "lamp-post-glow",
      "name": "Lamp Post Torch",
      "description": "A pocket torch filled with the soft glow of an old lamp post. It lights the way home with a gentle orange hum.",
      "rarity": "common",
      "emoji": "🔦",
      "palette": "#FFC93C",
      "slot": "hand"
    },
    {
      "id": "leaf-boat",
      "name": "Leaf Boat Flip-Flops",
      "description": "Flip-flops cut from two big autumn leaves that once sailed a gutter stream. They float perfectly in puddles.",
      "rarity": "common",
      "emoji": "🩴",
      "palette": "#FF7F11",
      "slot": "feet"
    },
    {
      "id": "library-whisper",
      "name": "Library Reading Glasses",
      "description": "Round reading glasses from a quiet library corner. Through them, every sign reads like the first line of a story.",
      "rarity": "common",
      "emoji": "👓",
      "palette": "#9B5DE5",
      "slot": "face"
    },
    {
      "id": "lost-coat-button",
      "name": "Lost Button Pendant",
      "description": "A coat button that wandered off and found a new purpose on a ribbon. It hums softly when it spots its old coat.",
      "rarity": "common",
      "emoji": "🔘",
      "palette": "#FF6F91",
      "slot": "neck"
    },
    {
      "id": "morning-marble",
      "name": "Morning Marble Pyjamas",
      "description": "Soft pyjamas swirled yellow like a morning marble. Wear them and every day feels like a slow, sunny start.",
      "rarity": "common",
      "emoji": "👚",
      "palette": "#FF9F1C",
      "slot": "body"
    },
    {
      "id": "moss-pillow",
      "name": "Moss Slippers",
      "description": "Squishy slippers of springy park moss. They make even concrete feel like a forest floor.",
      "rarity": "common",
      "emoji": "🌿",
      "palette": "#52B788",
      "slot": "feet"
    },
    {
      "id": "mushroom-umbrella",
      "name": "Mushroom Cap",
      "description": "A spotted mushroom cap that keeps the drizzle off. Snails sometimes mistake you for a very tall toadstool.",
      "rarity": "common",
      "emoji": "🍄",
      "palette": "#FF595E",
      "slot": "head"
    },
    {
      "id": "pencil-stub-doodle",
      "name": "Doodled Tee",
      "description": "A plain tee covered in doodles by a pencil stub that refuses to stop drawing. The pictures change while you aren't looking.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#FB5607",
      "slot": "body"
    },
    {
      "id": "picnic-ant-parade",
      "name": "Picnic Ant",
      "description": "A tiny, very polite ant who marches alongside you on parade, always on the lookout for a dropped crumb.",
      "rarity": "common",
      "emoji": "🐜",
      "palette": "#FF6B6B",
      "slot": "companion"
    },
    {
      "id": "pocket-puddle",
      "name": "Puddle Shades",
      "description": "Sunglasses with lenses as dark and shiny as a fresh puddle. The world looks gently rippled through them.",
      "rarity": "common",
      "emoji": "🕶️",
      "palette": "#3FA9F5",
      "slot": "face"
    },
    {
      "id": "postcard-corner",
      "name": "Postcard Locket",
      "description": "A locket holding the torn corner of a postcard. Open it to read one warm line from someone far away.",
      "rarity": "common",
      "emoji": "💌",
      "palette": "#FF99C8",
      "slot": "neck"
    },
    {
      "id": "puddle-jumper-sock",
      "name": "Puddle Jumper Socks",
      "description": "Stripy socks that somehow stay dry after the biggest puddle jump. They demand to be shown off.",
      "rarity": "common",
      "emoji": "🧦",
      "palette": "#FF5DA2",
      "slot": "feet"
    },
    {
      "id": "rubber-duck-echo",
      "name": "Rubber Duck",
      "description": "A rubber duck that waddles along beside you and squeaks back whenever you say something nice.",
      "rarity": "common",
      "emoji": "🦆",
      "palette": "#FFD60A",
      "slot": "companion"
    },
    {
      "id": "seashell-murmur",
      "name": "Seashell Necklace",
      "description": "A necklace of tiny seashells that murmur the sea whenever you're nowhere near it.",
      "rarity": "common",
      "emoji": "🐚",
      "palette": "#FF8FAB",
      "slot": "neck"
    },
    {
      "id": "shoelace-squiggle",
      "name": "Squiggle Lace Trainers",
      "description": "Trainers with laces that tie themselves into a different squiggle every morning.",
      "rarity": "common",
      "emoji": "👟",
      "palette": "#06D6A0",
      "slot": "feet"
    },
    {
      "id": "sidewalk-chalk-spark",
      "name": "Chalk Spark Skates",
      "description": "Roller skates that leave a faint trail of chalk sparkles on every pavement they cross.",
      "rarity": "common",
      "emoji": "🛼",
      "palette": "#FFD23F",
      "slot": "feet"
    },
    {
      "id": "snail-trail-sparkle",
      "name": "Sparkle Snail",
      "description": "A patient snail who leaves a glittering trail and somehow always keeps up with you.",
      "rarity": "common",
      "emoji": "🐌",
      "palette": "#9EF01A",
      "slot": "companion"
    },
    {
      "id": "snoozy-acorn",
      "name": "Snoozy Acorn Cap",
      "description": "An acorn cap stretched to fit a person. Wearing it makes afternoon naps feel twice as cosy.",
      "rarity": "common",
      "emoji": "🌰",
      "palette": "#E8A33D",
      "slot": "head"
    },
    {
      "id": "street-sign-shimmer",
      "name": "Shimmering Sign",
      "description": "A tiny street sign on a stick that always points somewhere nice. The arrow shimmers when you're close.",
      "rarity": "common",
      "emoji": "🪧",
      "palette": "#00F5D4",
      "slot": "hand"
    },
    {
      "id": "sunflower-seed-smile",
      "name": "Sunflower Sun Hat",
      "description": "A wide straw hat with a sunflower on the band. The flower turns to follow the sun across the sky.",
      "rarity": "common",
      "emoji": "👒",
      "palette": "#FFBE0B",
      "slot": "head"
    },
    {
      "id": "teacup-ripple",
      "name": "Teacup Cardigan",
      "description": "A cardigan as warm as a cup of tea, with a gentle ripple pattern that spreads when you laugh.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#80ED99",
      "slot": "body"
    },
    {
      "id": "ticket-stub-thrill",
      "name": "Ticket Stub Top Hat",
      "description": "A top hat with a ticket stub tucked in the band. It hums the overture of a show nobody remembers.",
      "rarity": "common",
      "emoji": "🎩",
      "palette": "#FF006E",
      "slot": "head"
    },
    {
      "id": "twig-wand",
      "name": "Twig Wand",
      "description": "A slender twig that fell exactly where you were walking. Wave it and nearby leaves dance a little.",
      "rarity": "common",
      "emoji": "🪄",
      "palette": "#B5E48C",
      "slot": "hand"
    },
    {
      "id": "umbrella-drip",
      "name": "Drippy Umbrella",
      "description": "A dependable umbrella that drips one last, perfectly round drop long after the rain has stopped.",
      "rarity": "common",
      "emoji": "☂️",
      "palette": "#3A86FF",
      "slot": "hand"
    },
    {
      "id": "window-frost-doodle",
      "name": "Frost Doodle Goggles",
      "description": "Goggles etched with a frosty doodle from a winter window. Through them, every morning looks crisp and new.",
      "rarity": "common",
      "emoji": "🥽",
      "palette": "#90E0EF",
      "slot": "face"
    },
    {
      "id": "wobbly-spoon",
      "name": "Wobbly Spoon",
      "description": "A spoon that wobbles like jelly but somehow never spills. It conducts imaginary orchestras with great enthusiasm.",
      "rarity": "common",
      "emoji": "🥄",
      "palette": "#B388FF",
      "slot": "hand"
    },
    {
      "id": "backwards-clock-hand",
      "name": "Backwards Clock Pendant",
      "description": "A pendant clock whose hand ticks backwards. Wear it and you always seem to arrive a minute early.",
      "rarity": "uncommon",
      "emoji": "🕰️",
      "palette": "#E056FD",
      "slot": "neck"
    },
    {
      "id": "bottled-sunrise",
      "name": "Sunrise Shades",
      "description": "Sunglasses that hold one bottled sunrise. Put them on and every hour looks like golden morning.",
      "rarity": "uncommon",
      "emoji": "😎",
      "palette": "#FF7B00",
      "slot": "face"
    },
    {
      "id": "bouncing-breadcrumb",
      "name": "Breadcrumb Bounce Boots",
      "description": "Boots with soles as springy as fresh bread. Every step bounces, and they leave a trail you can always follow home.",
      "rarity": "uncommon",
      "emoji": "🥾",
      "palette": "#FFD166",
      "slot": "feet"
    },
    {
      "id": "chatty-compass",
      "name": "Chatty Compass Pendant",
      "description": "A compass pendant that chats away about the best direction to go. It's usually right, and always friendly.",
      "rarity": "uncommon",
      "emoji": "🧭",
      "palette": "#0ACF83",
      "slot": "neck"
    },
    {
      "id": "counting-sheep-cloud",
      "name": "Counting Sheep",
      "description": "A woolly little sheep that hops along beside you, counting itself softly until everyone nearby feels sleepy.",
      "rarity": "uncommon",
      "emoji": "🐑",
      "palette": "#E0AAFF",
      "slot": "companion"
    },
    {
      "id": "drumming-drainpipe",
      "name": "Drainpipe Drum",
      "description": "A small drum made from a section of drainpipe. It plays the rain's rhythm even on dry days.",
      "rarity": "uncommon",
      "emoji": "🥁",
      "palette": "#FF8C42",
      "slot": "hand"
    },
    {
      "id": "echo-in-a-jar",
      "name": "Echo in a Jar",
      "description": "A jar you carry with an echo trapped inside. Lift the lid and it repeats the last kind thing you said.",
      "rarity": "uncommon",
      "emoji": "🫙",
      "palette": "#00B4D8",
      "slot": "hand"
    },
    {
      "id": "endless-spinning-top",
      "name": "Spinning Top Propeller Cap",
      "description": "A cap topped with a spinning top that never slows. On a lucky gust, it lifts you very slightly off your heels.",
      "rarity": "uncommon",
      "emoji": "🌀",
      "palette": "#3D5AFE",
      "slot": "head"
    },
    {
      "id": "glow-in-the-day-star",
      "name": "Glow-in-the-Day Star Clip",
      "description": "A star-shaped hair clip that glows in broad daylight, as if it never got the memo about night time.",
      "rarity": "uncommon",
      "emoji": "⭐",
      "palette": "#FFD000",
      "slot": "head"
    },
    {
      "id": "gravity-shy-feather",
      "name": "Gravity-Shy Feather Hat",
      "description": "A feathered hat that drifts a hair above your head, because its feather is far too shy to touch anything.",
      "rarity": "uncommon",
      "emoji": "🪶",
      "palette": "#64DFDF",
      "slot": "head"
    },
    {
      "id": "hiccup-firefly",
      "name": "Hiccup Beetle",
      "description": "A glowing beetle that flickers on and off with the hiccups. It's very apologetic about it.",
      "rarity": "uncommon",
      "emoji": "🪲",
      "palette": "#A3FF6F",
      "slot": "companion"
    },
    {
      "id": "humming-teaspoon",
      "name": "Humming Tea Cosy",
      "description": "A tea cosy worn as a hat. It hums a cosy tune and keeps your thoughts warm on chilly walks.",
      "rarity": "uncommon",
      "emoji": "🫖",
      "palette": "#2DD4BF",
      "slot": "head"
    },
    {
      "id": "inside-out-umbrella",
      "name": "Inside-Out Umbrella",
      "description": "An umbrella that's permanently inside out, yet somehow keeps you drier than any ordinary one.",
      "rarity": "uncommon",
      "emoji": "🌂",
      "palette": "#F94144",
      "slot": "hand"
    },
    {
      "id": "jumping-jellybean",
      "name": "Jellybean Pogo Boots",
      "description": "Jellybean-coloured boots that hop of their own accord. Standing still is an achievement.",
      "rarity": "uncommon",
      "emoji": "👢",
      "palette": "#FF5D8F",
      "slot": "feet"
    },
    {
      "id": "melody-lock-key",
      "name": "Melody Key Necklace",
      "description": "An old key on a chain that opens locks when you hum the right tune. Nobody remembers which lock it was made for.",
      "rarity": "uncommon",
      "emoji": "🗝️",
      "palette": "#FFB703",
      "slot": "neck"
    },
    {
      "id": "mirror-puddle",
      "name": "Mirror Puddle Mask",
      "description": "A shiny mask with the surface of a still puddle. Whoever looks at you sees a cheerful reflection of themselves.",
      "rarity": "uncommon",
      "emoji": "🎭",
      "palette": "#56CFE1",
      "slot": "face"
    },
    {
      "id": "pocket-rainbow-prism",
      "name": "Rainbow Prism Specs",
      "description": "Spectacles with prism lenses that split every grey street into its hidden colours.",
      "rarity": "uncommon",
      "emoji": "🌈",
      "palette": "#FF4D6D",
      "slot": "face"
    },
    {
      "id": "pocketful-of-fog",
      "name": "Pocketful of Fog Hoodie",
      "description": "A soft grey hoodie whose front pocket breathes out a gentle, cosy fog whenever you need a little mystery.",
      "rarity": "uncommon",
      "emoji": "🌫️",
      "palette": "#B8C0FF",
      "slot": "body"
    },
    {
      "id": "polite-thundercloud",
      "name": "Polite Thundercloud",
      "description": "A small thundercloud that floats beside you and always says excuse me before it rumbles.",
      "rarity": "uncommon",
      "emoji": "🌩️",
      "palette": "#9D4EDD",
      "slot": "companion"
    },
    {
      "id": "puddle-fish",
      "name": "Puddle Fish",
      "description": "A shimmering fish that swims through the air beside you as if every street were a puddle.",
      "rarity": "uncommon",
      "emoji": "🐟",
      "palette": "#00C2D1",
      "slot": "companion"
    },
    {
      "id": "reverse-raindrop",
      "name": "Reverse Raindrop Raincoat",
      "description": "A raincoat whose droplets roll upwards and drift back into the sky. You're dry before you know it.",
      "rarity": "uncommon",
      "emoji": "🥼",
      "palette": "#4895EF",
      "slot": "body"
    },
    {
      "id": "shadow-puppet-bunny",
      "name": "Shadow Bunny",
      "description": "A bunny made of shadow that hops along at your feet, even when the sun is directly overhead.",
      "rarity": "uncommon",
      "emoji": "🐇",
      "palette": "#B892FF",
      "slot": "companion"
    },
    {
      "id": "sleepwalking-slipper",
      "name": "Sleepwalking Slippers",
      "description": "Slippers that know the way home by themselves. Perfect for very late nights and very early mornings.",
      "rarity": "uncommon",
      "emoji": "🥿",
      "palette": "#FF87AB",
      "slot": "feet"
    },
    {
      "id": "sneezing-snow-globe",
      "name": "Snow Globe Helmet",
      "description": "A glass dome helmet with a snow globe swirl inside. When it sneezes, a tiny blizzard swirls around your ears.",
      "rarity": "uncommon",
      "emoji": "🌨️",
      "palette": "#A2D2FF",
      "slot": "head"
    },
    {
      "id": "sticky-note-sprite",
      "name": "Sticky Note Poncho",
      "description": "A poncho made of overlapping sticky notes. A little sprite writes helpful reminders on them while you walk.",
      "rarity": "uncommon",
      "emoji": "📝",
      "palette": "#FFEE32",
      "slot": "body"
    },
    {
      "id": "teleporting-thimble",
      "name": "Teleporting Thimble",
      "description": "A thimble and thread you hold between two fingers. Pull the thread and it pops up somewhere slightly more useful.",
      "rarity": "uncommon",
      "emoji": "🧵",
      "palette": "#FF85A1",
      "slot": "hand"
    },
    {
      "id": "thumbnail-lighthouse",
      "name": "Thumbnail Lighthouse",
      "description": "A lighthouse no bigger than your thumb, held up high to sweep a beam of welcome across the street.",
      "rarity": "uncommon",
      "emoji": "🗼",
      "palette": "#00A6FB",
      "slot": "hand"
    },
    {
      "id": "ticklish-doorknob",
      "name": "Ticklish Doorknob Brooch",
      "description": "A brass doorknob worn at the collar. Give it a twist and it giggles, then opens a conversation.",
      "rarity": "uncommon",
      "emoji": "🚪",
      "palette": "#FF7096",
      "slot": "neck"
    },
    {
      "id": "weather-vane-rooster",
      "name": "Weather Vane Rooster",
      "description": "A small copper rooster who rides along beside you and crows to announce changes in the weather.",
      "rarity": "uncommon",
      "emoji": "🐓",
      "palette": "#FF9E00",
      "slot": "companion"
    },
    {
      "id": "whistling-keyhole",
      "name": "Keyhole Waistcoat",
      "description": "A smart waistcoat with a keyhole for a pocket. It whistles a cheerful tune when the wind blows through.",
      "rarity": "uncommon",
      "emoji": "👔",
      "palette": "#FFA62B",
      "slot": "body"
    },
    {
      "id": "aurora-ribbon",
      "name": "Aurora Bow Tie",
      "description": "A bow tie that ripples green, violet and gold like the northern lights, knotted from a ribbon of sky.",
      "rarity": "rare",
      "emoji": "🎀",
      "palette": "#06FFA5",
      "slot": "neck"
    },
    {
      "id": "bottled-thunderclap",
      "name": "Thunderclap Wand",
      "description": "A wand with a thunderclap bottled in the tip. One flick and every head in the street turns to look.",
      "rarity": "rare",
      "emoji": "⚡",
      "palette": "#FFD60A",
      "slot": "hand"
    },
    {
      "id": "bubble-carousel",
      "name": "Bubble Carousel Hat",
      "description": "A hat with a tiny carousel of bubble horses spinning around the crown, playing a faraway fairground tune.",
      "rarity": "rare",
      "emoji": "🎠",
      "palette": "#FF85D8",
      "slot": "head"
    },
    {
      "id": "clockwork-hummingbird",
      "name": "Clockwork Hummingbird",
      "description": "A brass hummingbird that hovers at your shoulder, its blurred wings ticking like a pocket watch.",
      "rarity": "rare",
      "emoji": "🕊️",
      "palette": "#00F5D4",
      "slot": "companion",
      "parts": [
        {
          "id": "body",
          "name": "Brass Body"
        },
        {
          "id": "wings",
          "name": "Blurwing Pair"
        },
        {
          "id": "spring",
          "name": "Nectar Mainspring"
        }
      ]
    },
    {
      "id": "cloud-hopper-boots",
      "name": "Cloud Hopper Boots",
      "description": "Puffy boots that let you hop from one low cloud to the next, if you're brave enough to try.",
      "rarity": "rare",
      "emoji": "👢",
      "palette": "#FF9770",
      "slot": "feet",
      "parts": [
        {
          "id": "left",
          "name": "Left Cloud Boot"
        },
        {
          "id": "right",
          "name": "Right Cloud Boot"
        },
        {
          "id": "laces",
          "name": "Updraft Laces"
        }
      ]
    },
    {
      "id": "comet-marble",
      "name": "Comet Marble Monocle",
      "description": "A monocle cut from a comet marble. Through it, you can see the bright trail everything leaves behind.",
      "rarity": "rare",
      "emoji": "🔮",
      "palette": "#B15EFF",
      "slot": "face"
    },
    {
      "id": "daydream-telescope",
      "name": "Daydream Telescope",
      "description": "A brass telescope you carry everywhere. Peer through it to see what someone nearby is daydreaming.",
      "rarity": "rare",
      "emoji": "🔭",
      "palette": "#6C63FF",
      "slot": "hand",
      "parts": [
        {
          "id": "tube",
          "name": "Brass Tube"
        },
        {
          "id": "lens",
          "name": "Daydream Lens"
        },
        {
          "id": "cap",
          "name": "Starry Lens Cap"
        }
      ]
    },
    {
      "id": "ever-blooming-bouquet",
      "name": "Ever-Blooming Bouquet",
      "description": "A bouquet you hold that never wilts. A new flower opens every time you say thank you.",
      "rarity": "rare",
      "emoji": "💐",
      "palette": "#FF4F9A",
      "slot": "hand"
    },
    {
      "id": "firefly-choir-jar",
      "name": "Firefly Choir Lantern",
      "description": "A jam-jar lantern you carry by the lid, filled with fireflies that sing in perfect harmony after dark.",
      "rarity": "rare",
      "emoji": "🌟",
      "palette": "#FFE45E",
      "slot": "hand",
      "parts": [
        {
          "id": "jar",
          "name": "Jam Jar Glass"
        },
        {
          "id": "lid",
          "name": "Pinhole Lid"
        },
        {
          "id": "choir",
          "name": "Firefly Choir"
        }
      ]
    },
    {
      "id": "floating-lily-lamp",
      "name": "Floating Lily Crown",
      "description": "A crown of glowing water lilies that float a finger's width above your hair, lighting the way like a lamp.",
      "rarity": "rare",
      "emoji": "🪷",
      "palette": "#FF6EC7",
      "slot": "head"
    },
    {
      "id": "gearwork-snail",
      "name": "Gearwork Snail",
      "description": "A clockwork snail with a ticking shell that keeps perfect time as it trundles along beside you.",
      "rarity": "rare",
      "emoji": "🐌",
      "palette": "#74C0FC",
      "slot": "companion",
      "parts": [
        {
          "id": "shell",
          "name": "Clockface Shell"
        },
        {
          "id": "gears",
          "name": "Pocket Gear Train"
        },
        {
          "id": "antennae",
          "name": "Ticking Antennae"
        }
      ]
    },
    {
      "id": "giggle-catcher-hoop",
      "name": "Giggle Catcher Necklace",
      "description": "A dreamcatcher pendant that catches stray giggles from the air and threads them onto silver beads.",
      "rarity": "rare",
      "emoji": "🕸️",
      "palette": "#F9C74F",
      "slot": "neck",
      "parts": [
        {
          "id": "hoop",
          "name": "Willow Hoop"
        },
        {
          "id": "web",
          "name": "Silver Web"
        },
        {
          "id": "beads",
          "name": "Chuckle Beads"
        }
      ]
    },
    {
      "id": "midnight-sundial",
      "name": "Midnight Sundial Hat",
      "description": "A wide-brimmed hat with a sundial on the crown that tells the time by moonlight as well as sun.",
      "rarity": "rare",
      "emoji": "🌞",
      "palette": "#FFCD38",
      "slot": "head",
      "parts": [
        {
          "id": "dial",
          "name": "Sunstone Brim"
        },
        {
          "id": "gnomon",
          "name": "Shadow Pin"
        }
      ]
    },
    {
      "id": "paper-crane-messenger",
      "name": "Paper Crane Messenger",
      "description": "A folded paper crane that flies beside you and carries messages to friends who need them most.",
      "rarity": "rare",
      "emoji": "🦢",
      "palette": "#FF477E",
      "slot": "companion"
    },
    {
      "id": "pocket-weather-globe",
      "name": "Weather Globe Helmet",
      "description": "A glass dome helmet with its own tiny sky inside. The forecast inside is always a little brighter than outside.",
      "rarity": "rare",
      "emoji": "🌦️",
      "palette": "#00BBF9",
      "slot": "head",
      "parts": [
        {
          "id": "dome",
          "name": "Glass Sky Dome"
        },
        {
          "id": "base",
          "name": "Cloudstone Rim"
        },
        {
          "id": "vane",
          "name": "Tiny Weather Vane"
        }
      ]
    },
    {
      "id": "rainbow-paint-pot",
      "name": "Rainbow Painter's Smock",
      "description": "A painter's smock with a pocket paint pot and a brush that splashes rainbows on whatever you wear underneath.",
      "rarity": "rare",
      "emoji": "🎨",
      "palette": "#FFB627",
      "slot": "body",
      "parts": [
        {
          "id": "pot",
          "name": "Prism Paint Pot"
        },
        {
          "id": "brush",
          "name": "Rainbow Brush"
        }
      ]
    },
    {
      "id": "rainmaker-teapot",
      "name": "Rainmaker Teapot",
      "description": "A flying teapot that floats beside you and pours a gentle drizzle onto any thirsty flowers you pass.",
      "rarity": "rare",
      "emoji": "🫖",
      "palette": "#1DD3B0",
      "slot": "companion",
      "parts": [
        {
          "id": "pot",
          "name": "Cloudclay Pot"
        },
        {
          "id": "spout",
          "name": "Drizzle Spout"
        },
        {
          "id": "lid",
          "name": "Thunder Lid"
        }
      ]
    },
    {
      "id": "singing-fountain-pen",
      "name": "Singing Fountain Pen",
      "description": "A fountain pen that sings each word as you write it. Your shopping lists become little operas.",
      "rarity": "rare",
      "emoji": "🖋️",
      "palette": "#5A4FFF",
      "slot": "hand",
      "parts": [
        {
          "id": "nib",
          "name": "Golden Nib"
        },
        {
          "id": "barrel",
          "name": "Lacquer Barrel"
        },
        {
          "id": "ink",
          "name": "Song Ink Cartridge"
        }
      ]
    },
    {
      "id": "snowflake-locket",
      "name": "Snowflake Locket",
      "description": "A frosted locket on an icicle chain, holding one snowflake that will never melt.",
      "rarity": "rare",
      "emoji": "❄️",
      "palette": "#8EECF5",
      "slot": "neck",
      "parts": [
        {
          "id": "case",
          "name": "Frosted Case"
        },
        {
          "id": "chain",
          "name": "Icicle Chain"
        },
        {
          "id": "flake",
          "name": "Forever Snowflake"
        }
      ]
    },
    {
      "id": "starlit-rain-umbrella",
      "name": "Starlit Rain Umbrella",
      "description": "An umbrella whose canopy is a slice of the night sky. Raindrops land on it as tiny shooting stars.",
      "rarity": "rare",
      "emoji": "☔",
      "palette": "#3D7BFF",
      "slot": "hand",
      "parts": [
        {
          "id": "canopy",
          "name": "Night Sky Canopy"
        },
        {
          "id": "handle",
          "name": "Crescent Handle"
        },
        {
          "id": "ribs",
          "name": "Starlit Ribs"
        }
      ]
    },
    {
      "id": "whispering-seashell-horn",
      "name": "Seashell Horn Pendant",
      "description": "A curling seashell horn worn on a cord. Lift it to your lips and it whispers the tide's latest gossip.",
      "rarity": "rare",
      "emoji": "📯",
      "palette": "#FF7EB3",
      "slot": "neck"
    },
    {
      "id": "wishing-well-bucket",
      "name": "Wishing Well Bucket Hat",
      "description": "A bucket hat made from a wishing well pail, rope tied under the chin. Coins tossed in come back as wishes.",
      "rarity": "rare",
      "emoji": "🪣",
      "palette": "#4D96FF",
      "slot": "head",
      "parts": [
        {
          "id": "pail",
          "name": "Wishwood Pail"
        },
        {
          "id": "rope",
          "name": "Endless Chin Rope"
        },
        {
          "id": "handle",
          "name": "Copper Wish Handle"
        }
      ]
    },
    {
      "id": "cartographers-living-atlas",
      "name": "Cartographer's Atlas Coat",
      "description": "A long coat whose lining is a living atlas. New streets ink themselves onto it as you explore them.",
      "rarity": "epic",
      "emoji": "📖",
      "palette": "#FF9505",
      "slot": "body",
      "parts": [
        {
          "id": "cover",
          "name": "Wandering Leather Coat"
        },
        {
          "id": "pages",
          "name": "Self-inking Lining"
        },
        {
          "id": "ribbon",
          "name": "Bookmark Sash"
        },
        {
          "id": "clasp",
          "name": "Compass Clasp"
        }
      ]
    },
    {
      "id": "garden-of-small-suns",
      "name": "Garden of Small Suns Hat",
      "description": "A planter hat sprouting tiny suns instead of flowers. You stay warm and slightly golden all day.",
      "rarity": "epic",
      "emoji": "🌺",
      "palette": "#FF6D00",
      "slot": "head",
      "parts": [
        {
          "id": "planter",
          "name": "Terracotta Planter"
        },
        {
          "id": "soil",
          "name": "Starlit Soil"
        },
        {
          "id": "suns",
          "name": "Sprouting Suns"
        }
      ]
    },
    {
      "id": "glimmerwing-lantern",
      "name": "Glimmerwing Lantern",
      "description": "A paper lantern you carry on a bamboo frame, its everflame wick kissed by moths. It never gutters in the wind.",
      "rarity": "epic",
      "emoji": "🏮",
      "palette": "#FF7A59",
      "slot": "hand",
      "parts": [
        {
          "id": "frame",
          "name": "Bamboo Frame"
        },
        {
          "id": "wick",
          "name": "Everflame Wick"
        },
        {
          "id": "glass",
          "name": "Moth-kissed Glass"
        }
      ]
    },
    {
      "id": "lighthouse-in-a-bottle",
      "name": "Lighthouse Bottle Pendant",
      "description": "A sea-glass bottle worn on a chain with a whole lighthouse inside. Its lamp turns to guide lost friends to you.",
      "rarity": "epic",
      "emoji": "🍾",
      "palette": "#00B4D8",
      "slot": "neck",
      "parts": [
        {
          "id": "bottle",
          "name": "Sea Glass Bottle"
        },
        {
          "id": "tower",
          "name": "Tiny Tower"
        },
        {
          "id": "lamp",
          "name": "Ever-turning Lamp"
        }
      ]
    },
    {
      "id": "meteor-hatchling-egg",
      "name": "Meteor Hatchling",
      "description": "A speckled egg from a fallen star that rolls along beside you, glowing brighter as it gets ready to hatch.",
      "rarity": "epic",
      "emoji": "🥚",
      "palette": "#FF85A1",
      "slot": "companion",
      "parts": [
        {
          "id": "shell",
          "name": "Speckled Starshell"
        },
        {
          "id": "yolk",
          "name": "Glowing Starlight Yolk"
        }
      ]
    },
    {
      "id": "midnight-carousel-horse",
      "name": "Midnight Carousel Horse",
      "description": "A carousel horse that slipped its pole at midnight and now trots beside you, mane jingling with fairground bells.",
      "rarity": "epic",
      "emoji": "🐴",
      "palette": "#F72585",
      "slot": "companion"
    },
    {
      "id": "mirror-of-kind-words",
      "name": "Lorgnette of Kind Words",
      "description": "Glasses on a pearl handle that you raise to your eyes. Through them you read the kindest thing anyone thinks of you.",
      "rarity": "epic",
      "emoji": "🪞",
      "palette": "#E040FB",
      "slot": "face",
      "parts": [
        {
          "id": "glass",
          "name": "Kindness Lenses"
        },
        {
          "id": "frame",
          "name": "Silverleaf Frame"
        },
        {
          "id": "handle",
          "name": "Pearl Handle"
        }
      ]
    },
    {
      "id": "sky-whale-calf",
      "name": "Sky Whale Calf",
      "description": "A baby whale that swims through the air beside you, humming low songs that make the clouds gather to listen.",
      "rarity": "epic",
      "emoji": "🐋",
      "palette": "#4CC9F0",
      "slot": "companion"
    },
    {
      "id": "stillness-pocketwatch",
      "name": "Stillness Pocketwatch",
      "description": "A gilded pocketwatch on a chain. Open its case and the whole world holds still for one deep, calm breath.",
      "rarity": "epic",
      "emoji": "⏱️",
      "palette": "#FFC857",
      "slot": "neck",
      "parts": [
        {
          "id": "case",
          "name": "Gilded Case"
        },
        {
          "id": "face",
          "name": "Moonphase Face"
        },
        {
          "id": "hands",
          "name": "Stillness Hands"
        },
        {
          "id": "crown",
          "name": "Winding Crown"
        }
      ]
    },
    {
      "id": "storm-herders-bell",
      "name": "Storm Herder's Bell",
      "description": "A thunderbronze hand bell that gathers stray storms like sheep and leads them gently out of town.",
      "rarity": "epic",
      "emoji": "🛎️",
      "palette": "#8B5CF6",
      "slot": "hand",
      "parts": [
        {
          "id": "bell",
          "name": "Thunderbronze Bell"
        },
        {
          "id": "clapper",
          "name": "Lightning Clapper"
        },
        {
          "id": "strap",
          "name": "Cloudwool Strap"
        }
      ]
    },
    {
      "id": "tidecaller-conch",
      "name": "Tidecaller Conch",
      "description": "A pearl-spiral conch you hold to call the tide. Even far inland, a salty breeze answers.",
      "rarity": "epic",
      "emoji": "🐚",
      "palette": "#00D2FF",
      "slot": "hand",
      "parts": [
        {
          "id": "shell",
          "name": "Pearl Spiral Shell"
        },
        {
          "id": "mouthpiece",
          "name": "Coral Mouthpiece"
        }
      ]
    },
    {
      "id": "wandering-door-knocker",
      "name": "Lion Knocker Waistcoat",
      "description": "A grand waistcoat fastened by a lion door knocker that roams between buttons and roars hello to strangers.",
      "rarity": "epic",
      "emoji": "🦁",
      "palette": "#FFB000",
      "slot": "body"
    },
    {
      "id": "clock-at-worlds-heart",
      "name": "Clockheart Breastplate",
      "description": "A breastplate with the clock at the world's heart set in its centre. It chimes in time with your heartbeat.",
      "rarity": "legendary",
      "emoji": "⏰",
      "palette": "#FF4081",
      "slot": "body",
      "parts": [
        {
          "id": "face",
          "name": "Starlit Face"
        },
        {
          "id": "pendulum",
          "name": "Twin-world Pendulum"
        },
        {
          "id": "gears",
          "name": "Heartbeat Gears"
        },
        {
          "id": "chime",
          "name": "Midnight Chime"
        }
      ]
    },
    {
      "id": "crown-of-seasons",
      "name": "Crown of Seasons",
      "description": "A crown of four bands, one for each season. The weather around you shifts gently to match whichever band glows.",
      "rarity": "legendary",
      "emoji": "👑",
      "palette": "#FFD700",
      "slot": "head",
      "parts": [
        {
          "id": "spring",
          "name": "Blossom Band"
        },
        {
          "id": "summer",
          "name": "Sunlit Band"
        },
        {
          "id": "autumn",
          "name": "Amber Leaf Band"
        },
        {
          "id": "winter",
          "name": "Frost Band"
        }
      ]
    },
    {
      "id": "ethrling-queens-marble",
      "name": "Ethrling Queen's Sceptre",
      "description": "A sceptre crowned by the marble of the Ethrling Queen. Inside it, the whole shimmering Ethr turns slowly.",
      "rarity": "legendary",
      "emoji": "💫",
      "palette": "#F500FF",
      "slot": "hand"
    },
    {
      "id": "first-lantern-of-dusk",
      "name": "First Lantern of Dusk",
      "description": "The first lantern ever lit at dusk, floating beside you. Wherever it drifts, evening arrives softly and kindly.",
      "rarity": "legendary",
      "emoji": "🕯️",
      "palette": "#FF8C00",
      "slot": "companion",
      "parts": [
        {
          "id": "candle",
          "name": "Dawnwax Candle"
        },
        {
          "id": "flame",
          "name": "First Flame"
        },
        {
          "id": "holder",
          "name": "Twilight Holder"
        }
      ]
    },
    {
      "id": "heart-of-the-ethr",
      "name": "Heart of the Ethr Amulet",
      "description": "An amulet holding the shimmering heart of the Ethr itself. It pulses gently whenever something wonderful is near.",
      "rarity": "legendary",
      "emoji": "💠",
      "palette": "#00E5FF",
      "slot": "neck",
      "parts": [
        {
          "id": "core",
          "name": "Shimmering Core"
        },
        {
          "id": "shell",
          "name": "Prismatic Shell"
        },
        {
          "id": "pulse",
          "name": "Gentle Pulse"
        }
      ]
    },
    {
      "id": "rainbow-root-seed",
      "name": "Rainbow Root Sandals",
      "description": "Sandals sprouting from a rainbow seed. Each step plants a root of colour that blooms long after you've passed.",
      "rarity": "legendary",
      "emoji": "🌱",
      "palette": "#1DE9B6",
      "slot": "feet",
      "parts": [
        {
          "id": "husk",
          "name": "Opal Husk Soles"
        },
        {
          "id": "sprout",
          "name": "Rainbow Sprout Straps"
        }
      ]
    },
    {
      "id": "star-whales-song",
      "name": "Star Whale Song Mask",
      "description": "A mask that carries the song of a star whale. Wearing it, you hear the sky humming in every quiet moment.",
      "rarity": "legendary",
      "emoji": "🎼",
      "palette": "#7C4DFF",
      "slot": "face"
    },
    {
      "id": "aws-baseball-cap-red",
      "name": "AWS Baseball Cap",
      "description": "A classic red baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#E53935",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-orange",
      "name": "AWS Baseball Cap",
      "description": "A classic orange baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#FB8C00",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-yellow",
      "name": "AWS Baseball Cap",
      "description": "A classic yellow baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#FDD835",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-green",
      "name": "AWS Baseball Cap",
      "description": "A classic green baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#43A047",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-blue",
      "name": "AWS Baseball Cap",
      "description": "A classic blue baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#1E88E5",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-purple",
      "name": "AWS Baseball Cap",
      "description": "A classic purple baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#8E24AA",
      "slot": "head"
    },
    {
      "id": "aws-baseball-cap-white",
      "name": "AWS Baseball Cap",
      "description": "A classic white baseball cap with a curved brim and a blank front panel, ready for a logo. Sturdy, comfortable and always ready for a day in the cloud.",
      "rarity": "common",
      "emoji": "🧢",
      "palette": "#F5F5F5",
      "slot": "head"
    },
    {
      "id": "aws-hoodie-red",
      "name": "AWS Hoodie",
      "description": "A cosy red pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#E53935",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-orange",
      "name": "AWS Hoodie",
      "description": "A cosy orange pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#FB8C00",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-yellow",
      "name": "AWS Hoodie",
      "description": "A cosy yellow pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#FDD835",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-green",
      "name": "AWS Hoodie",
      "description": "A cosy green pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#43A047",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-blue",
      "name": "AWS Hoodie",
      "description": "A cosy blue pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#1E88E5",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-purple",
      "name": "AWS Hoodie",
      "description": "A cosy purple pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#8E24AA",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-white",
      "name": "AWS Hoodie",
      "description": "A cosy white pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Soft, warm and perfect for long nights in the cloud.",
      "rarity": "common",
      "emoji": "🧥",
      "palette": "#F5F5F5",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-red",
      "name": "AWS T-Shirt",
      "description": "A simple red crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#E53935",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-orange",
      "name": "AWS T-Shirt",
      "description": "A simple orange crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#FB8C00",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-yellow",
      "name": "AWS T-Shirt",
      "description": "A simple yellow crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#FDD835",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-green",
      "name": "AWS T-Shirt",
      "description": "A simple green crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#43A047",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-blue",
      "name": "AWS T-Shirt",
      "description": "A simple blue crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#1E88E5",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-purple",
      "name": "AWS T-Shirt",
      "description": "A simple purple crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#8E24AA",
      "slot": "body"
    },
    {
      "id": "aws-tshirt-white",
      "name": "AWS T-Shirt",
      "description": "A simple white crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. Light, comfy and just right for a day in the cloud.",
      "rarity": "common",
      "emoji": "👕",
      "palette": "#F5F5F5",
      "slot": "body"
    },
    {
      "id": "aws-baseball-cap-silver",
      "name": "Silver AWS Baseball Cap",
      "description": "A shining silver baseball cap with a curved brim and a blank front panel, ready for a logo. A rare treat that catches every light in the cloud.",
      "rarity": "uncommon",
      "emoji": "🧢",
      "palette": "#C0C8D4",
      "slot": "head"
    },
    {
      "id": "aws-tshirt-silver",
      "name": "Silver AWS T-Shirt",
      "description": "A shining silver crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. It glints with every step through the cloud.",
      "rarity": "uncommon",
      "emoji": "👕",
      "palette": "#C0C8D4",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-silver",
      "name": "Silver AWS Hoodie",
      "description": "A shining silver pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Warm, bold and impossible to miss in the cloud.",
      "rarity": "uncommon",
      "emoji": "🧥",
      "palette": "#C0C8D4",
      "slot": "body"
    },
    {
      "id": "aws-baseball-cap-gold",
      "name": "Gold AWS Baseball Cap",
      "description": "A gleaming gold baseball cap with a curved brim and a blank front panel, ready for a logo. A rare treat that catches every light in the cloud.",
      "rarity": "rare",
      "emoji": "🧢",
      "palette": "#FFD700",
      "slot": "head"
    },
    {
      "id": "aws-tshirt-gold",
      "name": "Gold AWS T-Shirt",
      "description": "A gleaming gold crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. It glints with every step through the cloud.",
      "rarity": "rare",
      "emoji": "👕",
      "palette": "#FFD700",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-gold",
      "name": "Gold AWS Hoodie",
      "description": "A gleaming gold pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Warm, bold and impossible to miss in the cloud.",
      "rarity": "rare",
      "emoji": "🧥",
      "palette": "#FFD700",
      "slot": "body"
    },
    {
      "id": "aws-baseball-cap-sparkly",
      "name": "Sparkly AWS Baseball Cap",
      "description": "A dazzling, glitter-covered holographic baseball cap with a curved brim and a blank front panel, ready for a logo. A rare treat that catches every light in the cloud.",
      "rarity": "legendary",
      "emoji": "🧢",
      "palette": "#E040FB",
      "slot": "head"
    },
    {
      "id": "aws-tshirt-sparkly",
      "name": "Sparkly AWS T-Shirt",
      "description": "A dazzling, glitter-covered holographic crew-neck t-shirt with short sleeves and a blank chest, ready for a logo. It glints with every step through the cloud.",
      "rarity": "legendary",
      "emoji": "👕",
      "palette": "#E040FB",
      "slot": "body"
    },
    {
      "id": "aws-hoodie-sparkly",
      "name": "Sparkly AWS Hoodie",
      "description": "A dazzling, glitter-covered holographic pullover hoodie with long sleeves, a front pocket and a blank chest, ready for a logo. Warm, bold and impossible to miss in the cloud.",
      "rarity": "legendary",
      "emoji": "🧥",
      "palette": "#E040FB",
      "slot": "body"
    },
    {
      "id": "aws-pants-red",
      "name": "AWS Pants",
      "description": "Smart, comfortable red pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#E53935",
      "slot": "legs"
    },
    {
      "id": "aws-pants-orange",
      "name": "AWS Pants",
      "description": "Smart, comfortable orange pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#FB8C00",
      "slot": "legs"
    },
    {
      "id": "aws-pants-yellow",
      "name": "AWS Pants",
      "description": "Smart, comfortable yellow pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#FDD835",
      "slot": "legs"
    },
    {
      "id": "aws-pants-green",
      "name": "AWS Pants",
      "description": "Smart, comfortable green pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#43A047",
      "slot": "legs"
    },
    {
      "id": "aws-pants-blue",
      "name": "AWS Pants",
      "description": "Smart, comfortable blue pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#1E88E5",
      "slot": "legs"
    },
    {
      "id": "aws-pants-purple",
      "name": "AWS Pants",
      "description": "Smart, comfortable purple pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#8E24AA",
      "slot": "legs"
    },
    {
      "id": "aws-pants-white",
      "name": "AWS Pants",
      "description": "Smart, comfortable white pants with a plain waistband and straight legs, ready for anything. Easy to wear for a long day of hunting in the cloud.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#F5F5F5",
      "slot": "legs"
    },
    {
      "id": "aws-pants-silver",
      "name": "Silver AWS Pants",
      "description": "Shining silver pants with a plain waistband and straight legs. They glint with every step through the cloud.",
      "rarity": "uncommon",
      "emoji": "👖",
      "palette": "#C0C8D4",
      "slot": "legs"
    },
    {
      "id": "aws-pants-gold",
      "name": "Gold AWS Pants",
      "description": "Gleaming gold pants with a plain waistband and straight legs. Rich, warm and impossible to overlook in the cloud.",
      "rarity": "rare",
      "emoji": "👖",
      "palette": "#FFD700",
      "slot": "legs"
    },
    {
      "id": "aws-pants-sparkly",
      "name": "Sparkly AWS Pants",
      "description": "Dazzling, glitter-covered holographic pants with a plain waistband and straight legs. Bold, bright and impossible to miss in the cloud.",
      "rarity": "legendary",
      "emoji": "👖",
      "palette": "#E040FB",
      "slot": "legs"
    },
    {
      "id": "aws-jeans-blue",
      "name": "Blue Jeans",
      "description": "Classic blue denim jeans with seams, stitching and a button waist. Tough, faded in all the right places and made for wandering.",
      "rarity": "common",
      "emoji": "👖",
      "palette": "#2F5C9E",
      "slot": "legs"
    },
    {
      "id": "aws-jean-shorts-blue",
      "name": "Jean Shorts",
      "description": "Light blue denim shorts that end at the knee, with seams and stitching. Breezy, relaxed and perfect for a sunny stroll.",
      "rarity": "common",
      "emoji": "🩳",
      "palette": "#5B86C7",
      "slot": "legs"
    }
  ]
}
